import { SortOrder } from '@iotv/iotv-v3-types'
type HasTimestamp = { timestamp: number }
type HasId = { id: string }
type HasName = {
  [k: string]: any
  name?: string
}

export const sortByTimestamp = (sn1: HasTimestamp, sn2: HasTimestamp, sort: SortOrder = SortOrder.ASCENDING) => {
  return sort * (sn1.timestamp - sn2.timestamp)
}

export const sortById = (sn1: HasId, sn2: HasId, sort: SortOrder = SortOrder.ASCENDING) => {
  return sort * (sn1.id < sn2.id ? -1 : 1)
}

export const sortByName = (sn1: HasName, sn2: HasName, sort: SortOrder = SortOrder.ASCENDING) => {
  return sort * ((sn1.name ?? '') < (sn2.name ?? '') ? -1 : 1)
}
